import { render } from "./ConfirmHost.vue?vue&type=template&id=17b24790"
import script from "./ConfirmHost.vue?vue&type=script&lang=js"
export * from "./ConfirmHost.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__